import { WebCallService } from "@/utilities/services/WebCallService";
import { PathHelper } from "@/utilities/helpers/PathHelper";
import { HttpType } from "@/utilities/enums/Enums";

export class CustomLocalService {
    private webCaller: WebCallService;
    private uriHelper: PathHelper;

    constructor() {
        this.webCaller = new WebCallService();
        this.uriHelper = new PathHelper();
    }


    public async getLanguageByName(name: string): Promise<any> {
        const uri = this.uriHelper.customLanguage.getLanguageByNamePath(name);
        return await this.webCaller.HttpSend(HttpType.get, uri);
    }

   

}
